import React, { useEffect, useState } from "react";
import { db, auth } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

const UserList = ({ onSelectUser }) => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchUsers = async () => {
      const userSnapshot = await getDocs(collection(db, "users"));
      const userList = userSnapshot.docs
        .map(doc => doc.data())
        .filter(user => user.uid !== auth.currentUser?.uid);
      setUsers(userList);
    };
    fetchUsers();
  }, []);

  const filteredUsers = users.filter(user =>
    `${user.firstName} ${user.lastName}`.toLowerCase().includes(search.toLowerCase()) ||
    user.email.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ width: "250px", borderRight: "1px solid #ccc", padding: "10px" }}>
      <h3>Users</h3>
      <input
        type="text"
        placeholder="Search by name or email"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ width: "100%", marginBottom: "10px", padding: "5px" }}
      />
      {filteredUsers.map(user => (
        <div key={user.uid} style={{ padding: "5px 0", cursor: "pointer" }} onClick={() => onSelectUser(user)}>
          {user.firstName} {user.lastName}
        </div>
      ))}
    </div>
  );
};

export default UserList;